import { useState, useEffect, Fragment } from "react";
import { FormGroup, FormLabel, FormControl, FormText } from "react-bootstrap";
import * as yup from "yup";
import PlacesAutocomplete, {
  geocodeByPlaceId,
  getLatLng,
} from "react-places-autocomplete";

export default function AddressInput({
  name,
  label,
  errorLabel,
  required,
  type,
  defaultValue,
  setValue,
  trigger,
  
  // defaultValue ,
  ...props
}) {
  const [value, setLocalValue] = useState(defaultValue || "");
  const [error, setError] = useState("");

  useEffect(() => {
    if (defaultValue) {
      setLocalValue(defaultValue); // Set initial value from defaultValue
      setValue(defaultValue); // Set the form's value using react-hook-form
    }
  }, [defaultValue, setValue]);
  useEffect(() => {
    if (!value && required) {
      setError(`${errorLabel ?? label} is required`);
    }
  }, []);

  const validate = (val) => {
    try {
      yup
        .string()
        .concat(
          required &&
            yup.string().required(`${errorLabel ?? label} is required`)
        )
        .validateSync(val);
      setError("");
    } catch (error) {
      setError(error.message);
    }
  };

  const handleValueChange = (val) => {
    setLocalValue(val);
    setValue(val);
    validate(val);
    trigger(); // Triggers form validation
  };

  function onFetchLatLng(placeId) {
    geocodeByPlaceId(placeId)
      .then((geocode) => {
        getLatLng(geocode?.[0])
          .then((coords) => {
            console.log(coords, "coords");

            props.onLatLongGet && props.onLatLongGet(coords);
           props.handleGetCharges && props.handleGetCharges(coords);
            // Do something with the coordinates if needed
          })
          .catch((err) => {
            console.error(err);
          });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <Fragment>
      <FormGroup>
        <div className="d-flex align-items-center justify-content-between">
          {label && (
            <FormLabel className="form-label text-uppercase fw-sbold m-0">
              {label}
            </FormLabel>
          )}
        </div>
        <PlacesAutocomplete
          value={value}
          onSelect={(val, placeId) => {
            onFetchLatLng(placeId);
            handleValueChange(val);
          
          }}
          onChange={(val) => {
            handleValueChange(val);
          }}
          onError={(val) => console.error("Google Map Error :", val)}
        >
          {({
            getInputProps,
            suggestions,
            getSuggestionItemProps,
            loading,
          }) => (
            <Fragment>
              <FormControl
                {...getInputProps()}
                name={name}
                value={value}
                onBlur={() => validate(value)}
                {...props}
                className="form-control"
              />
              <div className="autocomplete-dropdown-container">
                {suggestions.map((suggestion) => {
                  const className = suggestion.active
                    ? "suggestion-item--active"
                    : "suggestion-item";
                  const style = suggestion.active
                    ? {
                        backgroundColor: "rgb(204 214 239)",
                        cursor: "pointer",
                      }
                    : { backgroundColor: "#ffffff", cursor: "pointer" };
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}
                    >
                      <div className="google-select-pop">
                        {suggestion.description}
                      </div>
                    </div>
                  );
                })}
              </div>
            </Fragment>
          )}
        </PlacesAutocomplete>
        {/* {error && <FormText className="text-danger">{error}</FormText>} */}
      </FormGroup>
    </Fragment>
  );
}
